/**
 * AlertDot — a small red dot for the bottom-nav Bell icon.
 *
 * Visual rules:
 *   • Hidden when total === 0
 *   • Solid rose-500 dot otherwise
 *   • Pulse ring when high > 0 (high-severity alerts demand attention)
 *   • If total > 9 we show "9+" (so a noisy day doesn't blow out the icon)
 */
import React from 'react';

export function AlertDot({ total, high }) {
  if (!total || total <= 0) return null;
  const label = total > 9 ? '9+' : String(total);
  const wide = label.length > 1;
  return (
    <span
      data-testid="alert-dot"
      className={`absolute -top-0.5 ${wide ? '-right-1.5' : '-right-0.5'} flex items-center justify-center`}
    >
      {high > 0 && (
        <span className="absolute inline-flex h-3 w-3 rounded-full bg-rose-500 opacity-60 animate-ping" />
      )}
      <span className={`relative inline-flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold leading-none
        ${wide ? 'h-3.5 px-1' : 'h-3 w-3'}
      `}>
        {wide ? label : ''}
      </span>
    </span>
  );
}
